export var menuPositions = [
    "bottom-left",
    "bottom-right",
    "top-left",
    "top-right",
    "left-bottom",
    "left-top",
    "right-bottom",
    "right-top"
];
//# sourceMappingURL=menu-positions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/dropdown/menu-positions.js
// module id = 93
// module chunks = 4